import { navIndexReducer as navIndex } from './navModel';
import { locationReducer as location } from './location';
import { appNotificationsReducer as appNotifications } from './appNotification';

export default {
  navIndex,
  location,
  appNotifications,
};
